export default __webpack_public_path__ + "static/media/A002_012.b34f085c.jpeg";